import { Scroller, Slider, Overlay, Buttons } from '@cian/slider';
import { Image } from '@cian/ui-kit';
import * as React from 'react';

import { useOfferContext } from '../../../context';
import { PaginationDots } from '../PaginationDots';
import { Stub } from '../Stub';

interface ICarouselProps {
  withControls?: boolean;
  onSlideChange?(index: number): void;
}

export const Carousel: React.FC<ICarouselProps> = ({ withControls, onSlideChange }) => {
  const { offer } = useOfferContext();

  const { photos, id: offerId } = offer;

  const media = React.useMemo(
    () =>
      photos
        ? (photos.map(photo => photo.thumbnailUrl || photo.thumbnail2Url || photo.miniUrl).filter(Boolean) as string[])
        : [],
    [photos],
  );

  const showButtons = React.useMemo(() => media && media.length > 1, [media]);

  if (media.length === 0) {
    return <Stub key={`empty_image_${offerId}`} />;
  }

  return (
    <Slider onSlideChange={onSlideChange}>
      <Scroller>
        {media.map((url, index) => (
          <Image
            key={`image_${offerId}_${index}`}
            src={url}
            objectFit="cover"
            height={246}
            width={272}
            borderRadius="4px"
          />
        ))}
      </Scroller>
      <Overlay hideable={false}>
        {withControls && showButtons && <Buttons />}
        {showButtons && <PaginationDots />}
      </Overlay>
    </Slider>
  );
};
